<template>
  <div class="page-loadmore-wrapper">
    <mt-loadmore
      :auto-fill='false'
      :top-method="reload"
      :topPullText="$t('general.pulltext')"
      :topDropText="$t('general.droptext')"
      :topLoadingText="$t('general.loadingtext')"
      :bottom-method="getMore"
      @bottom-status-change="handleBottomChange"
      :bottom-all-loaded="allLoaded"
      ref="mt_loadmore"
      style="min-height: 100%;">
      <slot></slot>
        <div slot="bottom" class="mint-loadmore-bottom">
          <span v-show="bottomStatus === 'loading'">
            <mt-spinner type="snake"></mt-spinner>
          </span>
        </div>
    </mt-loadmore>
  </div>
</template>

<script>

export default {
  name: 'LoadMore',
  data () {
    return {
      bottomStatus: '',
      allLoaded: false
    }
  },
  props: {

  },
  methods: {
    getMore () {
      this.$emit('getMore')
    },
    handleBottomChange (status) {
      this.bottomStatus = status
    },
    reload() {
      this.$emit('reload')
      this.$refs.mt_loadmore.onTopLoaded();
    }
  }
}
</script>
